import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCloneStepRequest = {};
var _bulkCloneStepResponse = {};
var _bulkCreateStepMigrationRequest = { steps: '_step' };
var _bulkCreateStepMigrationResponse = { results: '_bulkStepResult' };
var _bulkCreateStepRequest = { steps: '_step' };
var _bulkCreateStepResponse = { results: '_bulkStepResult' };
var _bulkStepResult = { item: '_step' };
var _bulkUpdateStepResult = { item: '_step' };
var _bulkUpdateStepsRequest = { steps: '_maskedStep' };
var _bulkUpdateStepsResponse = { results: '_bulkUpdateStepResult' };
var _cloneStepRequest = {};
var _cloneStepResponse = { step: '_step' };
var _createStepRequest = { step: '_step' };
var _createStepResponse = { step: '_step' };
var _deleteAllProgramStepsRequest = {};
var _deleteAllProgramStepsResponse = {};
var _deleteStepRequest = {};
var _deleteStepResponse = {};
var _description = { image: '_image', video: '_videoV2' };
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _getStepRequest = {};
var _getStepResponse = { step: '_step' };
var _image = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _listAllProgramStepsRequest = {};
var _listAllProgramStepsResponse = { steps: '_step' };
var _maskedStep = { fieldMask: 'google.protobuf.FieldMask', step: '_step' };
var _moveStepRequest = {};
var _moveStepResponse = { step: '_step' };
var _queryStepsRequest = {};
var _queryStepsResponse = { steps: '_step' };
var _queryStepsWithoutPagingRequest = {};
var _queryStepsWithoutPagingResponse = { steps: '_step' };
var _quizOptions = { passingGrade: 'google.protobuf.DoubleValue' };
var _restoreStepFromTrashRequest = {};
var _restoreStepFromTrashResponse = { step: '_step' };
var _step = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    ordering: 'DOUBLE',
    videoOptions: '_videoOptions',
    quizOptions: '_quizOptions',
    description: '_description',
};
var _updateStepRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    step: '_step',
};
var _updateStepResponse = { step: '_step' };
var _videoOptions = {
    requiredCompletionPercentage: 'DOUBLE',
    video: '_videoV2',
    coverImage: '_image',
};
var _videoResolution = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    poster: '_image',
};
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_image',
};
function resolveWixOnlineprogramsStepsV3StepsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/program-steps-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/program-steps-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/program-steps-service',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/program-steps-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/program-steps-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/program-steps-service',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/program-steps-service',
                destPath: '',
            },
            {
                srcPath: '/program-steps-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/program-steps-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/program-steps-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/program-steps-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/program-steps-service',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/program-steps-service',
                destPath: '',
            },
            {
                srcPath: '/_api/program-steps-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/program-steps-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a Step. */
export function createStep(payload) {
    var _a = serializer(_createStepRequest, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createStepResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __createStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.CreateStep',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createStep.fromReq = fromReq;
    __createStep.__isAmbassador = true;
    return __createStep;
}
/** Creates steps in bulk. */
export function bulkCreateStep(payload) {
    var _a = serializer(_bulkCreateStepRequest, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateStepResponse, {
        _bulkStepResult: _bulkStepResult,
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __bulkCreateStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.BulkCreateStep',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/bulk/steps/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateStep.fromReq = fromReq;
    __bulkCreateStep.__isAmbassador = true;
    return __bulkCreateStep;
}
/** Internal endpoint to create steps in bulk for migration. Need to supply full entities which will be inserted in db as is. */
export function bulkCreateStepMigration(payload) {
    var _a = serializer(_bulkCreateStepMigrationRequest, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateStepMigrationResponse, {
        _bulkStepResult: _bulkStepResult,
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __bulkCreateStepMigration(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.BulkCreateStepMigration',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/bulk/steps/create/migration',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateStepMigration.fromReq = fromReq;
    __bulkCreateStepMigration.__isAmbassador = true;
    return __bulkCreateStepMigration;
}
/** Retrieves a Step. */
export function getStep(payload) {
    var _a = serializer(_getStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getStepResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.GetStep',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/{stepId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getStep.fromReq = fromReq;
    __getStep.__isAmbassador = true;
    return __getStep;
}
/** Update Step. */
export function updateStep(payload) {
    var _a = serializer(_updateStepRequest, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateStepResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __updateStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'PATCH',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.UpdateStep',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/{step.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateStep.fromReq = fromReq;
    __updateStep.__isAmbassador = true;
    return __updateStep;
}
/** Update multiple Steps in a single request. Works synchronously. */
export function bulkUpdateSteps(payload) {
    var _a = serializer(_bulkUpdateStepsRequest, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _maskedStep: _maskedStep,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateStepsResponse, {
        _bulkUpdateStepResult: _bulkUpdateStepResult,
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __bulkUpdateSteps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.BulkUpdateSteps',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/bulk/steps/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateSteps.fromReq = fromReq;
    __bulkUpdateSteps.__isAmbassador = true;
    return __bulkUpdateSteps;
}
/**
 * Deletes a Step.
 * Deleting a Step permanently removes them from the Step List.
 */
export function deleteStep(payload) {
    var _a = serializer(_deleteStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteStepResponse, {}).fromJSON;
    function __deleteStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'DELETE',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.DeleteStep',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/{stepId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteStep.fromReq = fromReq;
    __deleteStep.__isAmbassador = true;
    return __deleteStep;
}
/** Query steps. */
export function querySteps(payload) {
    var _a = serializer(_queryStepsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryStepsResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __querySteps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.QuerySteps',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __querySteps.fromReq = fromReq;
    __querySteps.__isAmbassador = true;
    return __querySteps;
}
/** Query steps without paging */
export function queryStepsWithoutPaging(payload) {
    var _a = serializer(_queryStepsWithoutPagingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryStepsWithoutPagingResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __queryStepsWithoutPaging(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.QueryStepsWithoutPaging',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/query/no-paging',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryStepsWithoutPaging.fromReq = fromReq;
    __queryStepsWithoutPaging.__isAmbassador = true;
    return __queryStepsWithoutPaging;
}
/** List all program steps without paging */
export function listAllProgramSteps(payload) {
    var _a = serializer(_listAllProgramStepsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAllProgramStepsResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __listAllProgramSteps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.ListAllProgramSteps',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/list/all',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAllProgramSteps.fromReq = fromReq;
    __listAllProgramSteps.__isAmbassador = true;
    return __listAllProgramSteps;
}
/** Delete all program steps */
export function deleteAllProgramSteps(payload) {
    var _a = serializer(_deleteAllProgramStepsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteAllProgramStepsResponse, {}).fromJSON;
    function __deleteAllProgramSteps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.DeleteAllProgramSteps',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/delete/all',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteAllProgramSteps.fromReq = fromReq;
    __deleteAllProgramSteps.__isAmbassador = true;
    return __deleteAllProgramSteps;
}
/** Clones all steps of prototype program */
export function bulkCloneStep(payload) {
    var _a = serializer(_bulkCloneStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCloneStepResponse, {}).fromJSON;
    function __bulkCloneStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.BulkCloneStep',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/bulk/steps/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCloneStep.fromReq = fromReq;
    __bulkCloneStep.__isAmbassador = true;
    return __bulkCloneStep;
}
/** Change Step position. */
export function moveStep(payload) {
    var _a = serializer(_moveStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_moveStepResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __moveStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'PATCH',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.MoveStep',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/{stepId}/move',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __moveStep.fromReq = fromReq;
    __moveStep.__isAmbassador = true;
    return __moveStep;
}
/** Clone Step. */
export function cloneStep(payload) {
    var _a = serializer(_cloneStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneStepResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __cloneStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.CloneStep',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/{stepId}/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneStep.fromReq = fromReq;
    __cloneStep.__isAmbassador = true;
    return __cloneStep;
}
/** Restore step from trash bin */
export function restoreStepFromTrash(payload) {
    var _a = serializer(_restoreStepFromTrashRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_restoreStepFromTrashResponse, {
        _description: _description,
        _focalPoint: _focalPoint,
        _image: _image,
        _quizOptions: _quizOptions,
        _step: _step,
        _videoOptions: _videoOptions,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __restoreStepFromTrash(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.RestoreStepFromTrash',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/restore',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __restoreStepFromTrash.fromReq = fromReq;
    __restoreStepFromTrash.__isAmbassador = true;
    return __restoreStepFromTrash;
}
//# sourceMappingURL=http.impl.js.map